import { render, staticRenderFns } from "./UComplyPage.vue?vue&type=template&id=4f114962&"
import script from "./UComplyPage.vue?vue&type=script&lang=js&"
export * from "./UComplyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports